import { useOverlayRuntime } from "@app/overlay/OverlayContext";

/**
 * Runtime-controls текущей dialog-surface.
 */
export function useDialogControls() {
    const runtime = useOverlayRuntime();

    if (runtime.surface !== "dialog") {
        throw new Error("useDialogControls must be used inside a dialog overlay surface.");
    }

    return {
        id: runtime.id,
        zIndex: runtime.zIndex,
        blocking: runtime.blocking,
        isTopmost: runtime.isTopmost,
        close: () => runtime.close(),
        resolve: runtime.resolveValue,
    };
}
